import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { StatementItemReference } from "@/payroll/ai-script/statement/statement-renderer";
import { isFigureValue } from "@/payroll/pack-chat/reference-label";

/** A compact summary of the figure selected for the new thread. */
export const SelectedStatementItemPreview = ({
  item,
}: {
  item: StatementItemReference;
}) => {
  const value = item.amount;
  const figure = isFigureValue(value);
  const details = [
    item.line ? item.heading : undefined,
    figure ? undefined : value,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Stack
      fullWidth
      direction="row"
      align="start"
      justify="between"
      gap="md"
      className="border-y border-stroke-tertiary py-3"
    >
      <Stack gap="none" align="stretch" className="min-w-0">
        <Typography variant="subtitleW3" className="truncate">
          {item.line ?? item.heading}
        </Typography>
        {details && (
          <Typography
            variant="bodyW3"
            textColor="secondary"
            className="truncate"
          >
            {details}
          </Typography>
        )}
      </Stack>
      {figure && value && (
        <Typography variant="subtitleW2" className="shrink-0">
          {value}
        </Typography>
      )}
    </Stack>
  );
};
